import { render, staticRenderFns } from "./genInfoForm.vue?vue&type=template&id=526d33b4"
import script from "./genInfoForm.vue?vue&type=script&lang=js"
export * from "./genInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports